enum Orientation {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}

export default Orientation;
